var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNfArrayObject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.7a1.25 1.25 0 0 1-.918-.382A1.252 1.252 0 0 1 6.7 3.4c0-.36.127-.666.381-.92.255-.253.56-.38.917-.38.358 0 .665.127.92.38.255.254.382.56.382.918s-.127.665-.382.92S8.358 4.7 8 4.7zm.002 3.6c-.358 0-.665-.127-.92-.382A1.25 1.25 0 0 1 6.7 7c0-.36.127-.666.382-.92.254-.253.56-.38.918-.38.36 0 .666.127.92.38.253.254.38.56.38.918s-.127.665-.38.92c-.254.255-.56.382-.918.382zm0 3.6c-.357 0-.664-.127-.92-.382A1.25 1.25 0 0 1 6.7 10.6c0-.36.128-.666.383-.92.255-.253.562-.38.92-.38s.664.127.917.38c.253.254.38.56.38.918s-.127.665-.38.92a1.246 1.246 0 0 1-.917.382zM0 0h4.2v1.825H2.418v10.35H4.2V14H0V0zm16 0h-4.2v1.825h1.782v10.35H11.8V14H16V0z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfArrayObject);
export default __webpack_public_path__ + "static/media/nf-array-object.6099c906138eb7c48f62feb05a63a032.svg";
export { ForwardRef as ReactComponent };